// lang/en.js
export default {
  copySuccess: "Copy successful",
  copyFail: "Copy fails, please try to copy manually",
  foot: {
    termsOfService: "Kebijakan Anggota",
    privacyPolicy: "Kebijakan Privasi",
    Notice: "Petunjuk Penting",
    EmailText: "Email CS:",
    info: "© NEXON Korea Corp.All Rights Reserved",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
  },
  notFound: {
    title: "Halaman yang Anda coba akses tidak ditemukan...",
    content:
      "Akan segera meninggalkan halaman ini, Akan kembali ke beranda secara otomatis dalam ",
    content2: " detik",
    btn: "Kembali ke beranda",
  },
};
